import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import type { GemstoneLine } from '@/features/pdp/utils/productDetailStones';

interface PdpDesktopGemstoneDetailsProps {
  gem: GemstoneLine;
}

export function PdpDesktopGemstoneDetails({ gem }: PdpDesktopGemstoneDetailsProps) {
  return (
    <>
      {gem.count != null ? <PdpDesktopDetailRow label="Count" value={gem.count} /> : null}
      <PdpDesktopDetailRow label="Stone Type" value={gem.type} />
    </>
  );
}
